export const BOOTSTRAP_BREAKPOINT = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 991,
  xl: 1200,
};
export { BOOTSTRAP_BREAKPOINT as default };
